import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/config';
import Button from '../../atoms/Button';
import SubHeadline from '../../atoms/SubHeadline';
import './style.scss';

const EmptyBasket = () => {
  const onBackToShoppingClicked = () => (window.location.href = '/');

  return (
    <div className="empty-basket-container">
      <img src={getAssetUrl('basket/empty.svg')} alt="" />
      <SubHeadline>
        <FormattedMessage id="basket.empty" />
      </SubHeadline>
      <Button onClick={onBackToShoppingClicked}>
        <FormattedMessage id="auth.backToShopping" />
      </Button>
    </div>
  );
};

export default EmptyBasket;
